export function dissoc(coll, keys) {
    for (let k of keys) {
        coll.delete(k);
    }
    return coll;
}
export const dissocObj = (obj, keys) => {
    for (let k of keys) {
        delete obj[k];
    }
    return obj;
};
